
import { useState } from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { CSVLink } from "react-csv";
import { useEffect } from "react";


const IncomingData = [
  {
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Returned",
    td8: "Bank Transfer",
  },
  {
    td1: "FKI3111",
    td2: "Mohan",
    td3: `Nike`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },{
    td1: "FKI456",
    td2: "Ram",
    td3: `Adidas`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },{
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Cancelled",
    td8: "Bank Transfer",
  },{
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Cancelled",
    td8: "Bank Transfer",
  },{
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Delivered",
    td8: "Bank Transfer",
  },{
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "In progress",
    td8: "Bank Transfer",
  },{
    td1: "FKI3066",
    td2: "Bedanta Baruah",
    td3: `Puma`,
    td4: "12th feb",
    td5: "12th may",
    td6: "9995",
    td7: "Cancelled",
    td8: "Bank Transfer",
  },
];

const DashboardTablesRender = () => {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [type, setType] = useState(0);

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => x.td7 === e.target.value));
  };

  const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  const handle3 = () => {
    setType(2);
  };

  useEffect(() => {
    if (type === 1) {
      setCount(IncomingData.filter((x) => x.td7 === "In progress"));
    } else if (type === 2) {
      setCount(IncomingData.filter((x) => x.td7 !== "In progress"));
    } else {
      setCount("");
    }
    setFiltr1("");
  }, [type]);

  return (
    <div id="OMS-main-content">
      <div className="order-list-box" >
        <div className="table_heading">
          <h4>ORDER SUMMARY / DETAILS</h4>
          <OpenInNewIcon
            style={{ fontSize: "16", marginLeft: "5" }}
          ></OpenInNewIcon>
        </div>
        <div id="click-data">
        <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
              All Invoice
            </p>
            <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
            Open Invoice
            </p>
            <p onClick={handle3} id={type === 2 ? "clicked-type" : ""}>
            Past Invoice
            </p>
        </div>
        <div className="order-list-input-box">
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by order ID, customer or item"
              onChange={(val) => {
                setCount(
                  IncomingData.filter((x) =>
                    x.td1.match(val.target.value) || x.td2.match(val.target.value) || x.td3.match(val.target.value)
                  )
                );
                setFiltr1("");
              }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            
          <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
              value={filtr1}
              onChange={handleFilter1}
              >
                <option selected>Order Status</option>
                <option value="Delivered">Delivered</option>
                <option value="Cancelled">Cancelled</option>
                <option value="In progress">In Progress</option>
                <option value="Returned">Returned</option>
              </select>
              <CSVLink
              data={IncomingData}
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </CSVLink>
            </div>
          </div>
        </div>
        <table style={{ textAlign: "center" }}>
          <tr>
            <th>Order ID</th>
            <th>Customers</th>
            <th>Item</th>
            <th>Order Date</th>
            <th>Delivery Date</th>
            <th>Amount</th>
            <th id='center'>Order Status</th>
            <th id='center'>Payment Method</th>
          </tr>
          {count.length > 0
            ? count.map((val) => {
                return (
                  <tr style={{lineHeight:"2rem"}}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td>{val.td4}</td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td  className="col-status"
                      id={
                        val.td7 === "Delivered"
                          ? "col-green"
                          : val.td7 === "Cancelled"
                          ? "col-red"
                          : val.td7 === "In progress"
                          ? "col-yellow"
                          : val.td7 === "Returned"
                          ? "col-blue"
                          : ""
                      }>{val.td7}</td>
                    <td id='center'>{val.td8}</td>
                  </tr>
                );
              })
            : IncomingData.map((val) => {
                return (
                  <tr style={{ lineHeight: "2rem" }}>
                    <td className="invoice-id">{val.td1}</td>
                    <td>{val.td2}</td>
                    <td>{val.td3}</td>
                    <td className="">
                      {val.td4}
                    </td>
                    <td>{val.td5}</td>
                    <td>{val.td6}</td>
                    <td  className="col-status"
                      id={
                        val.td7 === "Delivered"
                          ? "col-green"
                          : val.td7 === "Cancelled"
                          ? "col-red"
                          : val.td7 === "In progress"
                          ? "col-yellow"
                          : val.td7 === "Returned"
                          ? "col-blue"
                          : ""
                      }>{val.td7}</td>
                    <td id='center'>{val.td8}</td>
                  </tr>
                );
              })}
        </table>
      </div>
    </div>
    
  );
};

export default DashboardTablesRender;
